<template>
  <div class="app-footer-social-links">
    <div class="app-footer-social-links__title">{{ translate('Follow us') }}</div>
    <div class="app-footer-social-links__items">
      <a v-for="item in socials" :key="item.type" :href="item.url" target="_blank">
        <img :src="item.icon" :alt="item.alt" width="32" height="32" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFooterSocialLinks',
  data() {
    return {
      socials: [
        {
          type: 'youtube',
          alt: 'JobLeads Youtube Profile',
          icon: require('@/app/assets/socials/icon_youtube.svg'),
          url: 'https://www.youtube.com/channel/UCD-tDcD6v8Fr7ag0BOIRTyA',
        },
        {
          type: 'linkedin',
          alt: 'JobLeads Linkedin Profile',
          icon: require('@/app/assets/socials/icon_linkedin.svg'),
          url: 'https://www.linkedin.com/company/jobleads-gmbh/',
        },
        {
          type: 'instagram',
          alt: 'JobLeads Instagram Profile',
          icon: require('@/app/assets/socials/icon_instagram.svg'),
          url: 'https://www.instagram.com/jobleadscom/',
        },
        {
          type: 'facebook',
          alt: 'JobLeads Facebook Profile',
          icon: require('@/app/assets/socials/icon_facebook.svg'),
          url: 'https://www.facebook.com/JobLeads/',
        },
        {
          type: 'twitter',
          alt: 'JobLeads Twitter Account',
          icon: require('@/app/assets/socials/icon_twitter.svg'),
          url: 'https://twitter.com/JobLeads_de',
        },
        {
          type: 'xing',
          alt: 'JobLeads Xing Profile',
          icon: require('@/app/assets/socials/icon_xing.svg'),
          url: 'https://www.xing.com/pages/jobleadsgmbh',
        },
      ],
    };
  },
};
</script>
<style lang="scss">
.app-footer-social-links {
  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 16px;
  }
  &__items {
    display: flex;
    gap: 16px;
  }
}
</style>
